import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Danh sách vật tư của hợp đồng")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-hover" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Tên vật tư"),
    /*#__PURE__*/_createElementVNode("th", null, "Số lượng"),
    /*#__PURE__*/_createElementVNode("th", null, "Đơn giá"),
    /*#__PURE__*/_createElementVNode("th", null, "Thành tiền"),
    /*#__PURE__*/_createElementVNode("th", null, "Năm"),
    /*#__PURE__*/_createElementVNode("th", null, "Ngày tạo"),
    /*#__PURE__*/_createElementVNode("th", null, "Ngày cập nhật"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(item.so_luong), 1),
                  _createElementVNode("td", null, _toDisplayString(item.so_tien), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(parseFloat(item.so_tien) * item.so_luong, false)), 1),
                  _createElementVNode("td", null, _toDisplayString(item.nam), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.created_at).format("DD/MM/YYYY")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.updated_at).format("DD/MM/YYYY")), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}